import { render, staticRenderFns } from "./selectPolicyPopUp.vue?vue&type=template&id=ecde7dc6&scoped=true"
import script from "./selectPolicyPopUp.vue?vue&type=script&lang=js"
export * from "./selectPolicyPopUp.vue?vue&type=script&lang=js"
import style0 from "./selectPolicyPopUp.vue?vue&type=style&index=0&id=ecde7dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde7dc6",
  null
  
)

export default component.exports